export const stylesPRS = {
    listFavsItem:{
      padding: "6px 10px 12px 16px",
      marginBottom: "24px",
      borderRadius: "4px",
      boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.24), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)",
    },
    info:{
  width:"270px"
    },
    customHr:{
      width:"100%",
      border: "0",
      height: "1px",
      background: "#333",
      backgroundImage: "linear-gradient(to right, #333, #333, #333)",
      opacity: "0.1",
    },
    rowItems:{
      display: "flex",
      margin: "auto auto",
    },
    alias:{
      fontFamily: "Amx-Bold",
      fontSize: "14px",
      fontWeight: "700",
      lineHeight: "22px",
      color: "#50626C",
      padding: "0",
      margin: "0",
      width:"100%"
    },
    reference:{
      fontFamily: "Amx-Regular",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "22px",
      color: "#474747",
      padding: "0",
      margin: "0",
      with:"100%",
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '290px'
    },
    controlIcon:{
      position: "relative",
      display: "flex",
      alignItems: "end",
      justifyContent: "end",
      padding: "0px",
      width:"100%"
    },
    buttonIcon:{
      position: "absolute",
      right:0,
      border: "0",
      backgroundColor: "transparent",
    },
    leftBorder:{
      width: "1px",
      height: "16px",
      backgroundColor: "#D6D6D6",
      position: "absolute",
      left: "0",
      top: "50%",
      transform: "translate(0, -50%)",
    },
    rightBorder:{
      width: "1px",
      height: "16px",
      backgroundColor: "#D6D6D6",
      position: "absolute",
      right: "0",
      top: "50%",
      transform: "translate(0, -50%)",
    },
    titleText:{
      fontFamily: "Amx-Bold",
      fontSize: "20px",
      fontWeight: "700",
      lineHeight: "28px",
      color: "#000000",
      padding: "0",
      margin: "0 0 16px 0",
      textAlign: "center",
    },
    subTitleText:{
      fontFamily: "Amx-Regular",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      color: "#525252",
      padding: "0 32px",
      margin: "0 0 32px 0",
      textAlign: "center",
    },
    btnAccept:{
      textAlign: "center",
      display: "inline-block",
      backgroundColor: "#000" ,
      color: "#fff",
      paddingTop: "10px",
      paddingBottom: "10px",
      border: "0",
      borderRadius: "50px",
      margin: "0",
      width: "auto",
      minWidth: "51%",
      fontFamily: "Amx-Bold",
      fontSize: "16px",
      lineHeight: "24px",
    },
    switch: {
      position: 'absolute',
      display: 'inline-block',
      width: '44px',
      height: '20px',
    },
    input: {
      display: 'none',
    },
    slider: {
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor:'#9ccc64',
      transition: 'background-color 0.4s',
      color: '#fff',
      borderRadius: '34px',
    },
    sliderBefore: {
      position: 'absolute',
      content: '""',
      height: '12px',
      width: '12px',
      left:'28px' ,
      bottom: '4px',
      backgroundColor: 'white',
      transition: 'transform 0.4s',
      borderRadius: '50%'
    },
    sliderFalse: {
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor:  '#ccc',
      transition: 'background-color 0.4s',
      padding: '8px',
      color: '#fff',
      borderRadius: '34px',
    },
    sliderFalseBefore: {
      position: 'absolute',
      content: '""',
      height: '12px',
      width: '12px',
      left:  '10px',
      bottom: '4px',
      backgroundColor: 'white',
      transition: 'transform 0.4s',
      borderRadius: '50%'
    },
  }